export default __webpack_public_path__ + "static/media/omkar-karanje.592c0267.jpg";